import { DateRangePicker } from "@mui/x-date-pickers-pro";
import PropTypes from "prop-types";
import { useState } from "react";

export default function MyDateRangeSelector({
  dates = { startDate: null, endDate: null },
  setDates = () => {},
  disabled = false,
  fullWidth = false,
  onChangeEndTime = () => {},
  onChangeStartTime = () => {},
  localeText = { start: "Alku", end: "Loppu" },
  size = "small",
  variant = "outlined",
  ...props
}) {
  const [value, setValue] = useState([dates.startDate, dates.endDate]);

  const handleChange = (newValue) => {
    setValue(newValue);
    onChangeStartTime(newValue[0]);
    onChangeEndTime(newValue[1]);
    setDates({ startDate: newValue[0], endDate: newValue[1] });
  };

  return (
    <DateRangePicker
      disabled={disabled}
      fullWidth={fullWidth}
      value={value}
      localeText={localeText}
      onChange={handleChange}
      slotProps={{ textField: { size: size, variant: variant } }}
      {...props}
    />
  );
}

MyDateRangeSelector.propTypes = {
  dates: PropTypes.shape({
    startDate: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]),
    endDate: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]),
  }),
  disabled: PropTypes.bool,
  fullWidth: PropTypes.bool,
  onChangeEndTime: PropTypes.func,
  onChangeStartTime: PropTypes.func,
  setDates: PropTypes.func,
  localeText: PropTypes.object,
  size: PropTypes.oneOf(["small", "medium", "large"]),
  variant: PropTypes.oneOf(["standard", "outlined", "filled"]),
};
